module.exports = __webpack_public_path__ + "img/ACAD_D-2.290a02ab.png";